import ReactMarkdown from "react-markdown";

import { looksLikeHtml, sanitizeLegalHtml } from "./legalContentUtils";

type TLegalDocumentContentProps = {
  content: string;
  className?: string;
  emptyFallback?: string;
};

export function LegalDocumentContent({
  content,
  className = "markdown-content markdown-content--legal",
  emptyFallback = "_No content yet._",
}: TLegalDocumentContentProps) {
  const trimmed = content.trim();

  if (!trimmed) {
    return (
      <div className={className}>
        <ReactMarkdown>{emptyFallback}</ReactMarkdown>
      </div>
    );
  }

  if (looksLikeHtml(trimmed)) {
    return (
      <div
        className={className}
        dangerouslySetInnerHTML={{ __html: sanitizeLegalHtml(trimmed) }}
      />
    );
  }

  return (
    <div className={className}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
}
